const selectLocalNetworkAccessPermission = (state) =>
  state?.localNetworkAccess?.permissionState;

const selectShouldShowLocalNetworkAccessBanner = (state) =>
  selectLocalNetworkAccessPermission(state) === 'denied' &&
  state?.localNetworkAccess?.bannerDismissed === false;

export {
  selectLocalNetworkAccessPermission,
  selectShouldShowLocalNetworkAccessBanner,
};
